// Card #1652 (design §6.1/§6.2 type 5) — per-judge percentages, PERCENTAGES
// ONLY, never raw points (design §4.5/§6.2's exposure rule). The upstream
// shape (results.js's buildRideResult -> perJudge) only ever carries
// `percentage`, never a raw-points field, so there is nothing here that
// could accidentally leak one — this component simply never reads
// anything else off a row.
//
// A still-scoring judge's row has no `percentage` key (results.js
// ~421-430's PARTIAL suppression), but scoreboard-public.js ~747-756 passes
// `result.perJudge` through whenever the class has a panel regardless of
// whether the ride is PARTIAL or CONFIRMED — so a row missing `percentage`
// DOES reach this component on a still-scoring ride, it is not filtered out
// upstream. AC3 forbids rendering an omitted field empty (a bare judge
// position with nothing beside it), so a row with no percentage is dropped
// entirely here rather than rendered position-only.
// Card #1694 AC4 — percentage formatting goes through score-common's
// formatPercentage (3 decimals, single shared formatter) rather than a
// local `.toFixed()`.
import { formatPercentage } from "score-common";
import "./PerJudgeBreakout.css";

export default function PerJudgeBreakout({ perJudgeBreakout }) {
  const rows = (Array.isArray(perJudgeBreakout) ? perJudgeBreakout : []).filter(
    (row) => row?.percentage != null
  );
  if (!rows.length) return null;

  return (
    <ul className="per-judge-breakout" data-testid="per-judge-breakout">
      {rows.map((row, index) => (
        <li key={row.judgeId || index} className="per-judge-breakout__row" data-testid="per-judge-breakout-row">
          {row.position ? (
            <span className="per-judge-breakout__position" data-testid="per-judge-breakout-position">
              {row.position}
            </span>
          ) : null}
          <span className="per-judge-breakout__percentage" data-testid="per-judge-breakout-percentage">
            {formatPercentage(Number(row.percentage))}
          </span>
        </li>
      ))}
    </ul>
  );
}
